let clientList = [
  "conagra",
  'steelreserve',
  "uscc",
  "chamberlain",
  "cibc",
  "sca",
  "caterpillar",
  "shenshen",
  "range",
];

// portfolio content after client param is selected
let clientData = {
  sca: {
    client: "sca",
    title: "SCA Facilities: WordPress Multisite",
    description: `
    <h2>ABOUT SCA</h2>
    <p>Surgical Care Affiliates (SCA) is a national surgical solutions provider committed to improving healthcare in America.</p>
    <h2>ABOUT THE PROJECT</h2>  
    <p>As a contractor for Dept-11, I have had the opportunity to design and develop a WordPress Multisite Network for SCA. The goal was to create responsive website template with a content management system that could be administered by the various surgery centers across the US partnered with SCA. There are currently over 140 affiliate websites utilizing the template on the SCA WordPress Network.</p>
    <h3>SERVICES PROVIDED</h3>
    <ul>
      <li>Visual Design</li>
      <li>Front End Development</li>
      <li>Web Server Configuration</li>
      <li>WordPress Multisite Setup</li>
      <li>Responsive Custom Theme</li>
    </ul>
    <h3>A FEW NETWORK SITE LINKS</h3>
    <a class="work-external-link-text" href="https://stcsurgicalcenter.com/" target="_blank">St. Cloud Surgical Center</a> <br>    
    <a class="work-external-link-text" href="https://surgerycenteratmidorthoneuro.com/" target="_blank">Midlands Orthopaedics</a> <br>    
    <a class="work-external-link-text" href="https://scasurgery-affiliate.com/procedures-specialties/sample-procedure/" target="_blank">Development Template Page</a>,    
    `,
    logo: "logo-sca.png",
    images: ['sample-fpo.png', 'sample-fpo.png'],
    imageSet: [
      {
        src: 'sample-sca-01.png',
        caption: 'Desktop and mobile homepage design.'
      },
      {
        src: 'sample-sca-02.png',
        caption: 'Desktop and mobile homepage design.'
      },
      {
        src: 'sample-sca-03.png',
        caption: 'One of the initial design style tiles.'
      },
    ],
  },

  range: {
    client: "range",
    title: "Range Design & Architecture Website",
    link: "https://rangedesign.com/",
    description: `
      <h2>ABOUT RANGE</h2>
      
      <p>Range Design is a Chicago based architecture firm focusing on the intersection of art, architecture, design and landscape.</p>
      
      <h2>ABOUT THE PROJECT</h2>
      
      <!--<p>A WordPress REST backend with a Vue.js responsive frontend website.</p>-->
      
      <p>This site has a Vue.js front end that gets its data from a WordPress backend via WP’s REST API. The data for the site is managed in WordPress as Custom Post Types. This means the people at Range update the content for the site using WordPress' Admin interface.</p>
      
      <p>The site also has some custom JavaScript development, like the slideshow user interface for images in Featured and Projects. And the Archive has an animated sorting function.</p>
      
      <p>Range, originally called Kujawa Architecture, started as a Flash website with a custom built CRUD CMS that I developed while learning PHP. The Flash-based site ran for years along with the little CRUD CMS that could. The Flash site parsed XML that I generated from the mySQL/PHP backend. </p>
       
       <p>Kujawa became Range, I updated the site, turning the Flash site into a mobile-ready non-Flash version using the same backend CMS data. If you were on a desktop with an active Flash plugin-in, you would see the Flash site. If you didn't have Flash running or were on a mobile device, a responsive HTML/CSS/JS would display. Same backend data with PHP used on the front-end.</p>
       
      <h3>SERVICES PROVIDED</h3>
      <ul>
        <li>Web Server Configuration and Hosting</li>
        <li>WordPress Custom Post Types</li>
        <li>Back End Development</li>
        <li>Front End Development</li>
      </ul>
      <a class="work-external-link-text" href="https://rangedesign.com" target="_blank"><span>Visit</span> the site</a>
`,
    logo: "logo-range.png",
    images: ['sample-shenshen-02.png', 'sample-shenshen-01.png'],
    imageSet: [
      {
        src: 'sample-range-01.png',
        caption: 'Custom touch/slide featured showcase.'
      },
      {
        src: 'sample-range-02.png',
        caption: 'Grid with responsive layout.'
      },
    ],
  },

  caterpillar: {
    client: "caterpillar",
    title: "Together. Stronger. Caterpillar Foundation",
    link: "https://www.caterpillar.com/en/company/caterpillar-foundation.html",
    description: `
      <h2>ABOUT THE PROJECT</h2>
      <p>The Caterpillar Foundation believes that no one organization or individual can end extreme poverty. That’s why they created Together.Stronger. This collaborative impact platform unites business, non-profits, governments and citizens to combine their strengths to help 50 million people rise out of poverty by 2020.</p>
      <p><strong>PLEASE NOTE:</strong> a mobile experience was not a priority on this project, so I only developed the desktop version. There is a very minimal mobile representation, so this is best viewed on non-mobile device.</p>
      <p>As a subcontractor for Frequency 540, I worked with the Design team and Technical Director to develop a custom skinned data driven Google Map that when interacted with would display people's stories with text, pictures and/or video. My primary role was to develop the main map experience using custom data from Caterpillar and render its display for the front-end experience. </p>
      <p>
      Originally developed in 2015 and still running pretty well with no maintenance on my part. 
      </p>
      <p>
      To be honest, this project was a blur on a tight timeline with lots of moving parts. One of the most challenging projects I've worked on, from integrating with the CAT Technical team to help determine and deliver the data structures, to figuring out how to make custom SVG markers that looked great, to creating an "autoplay" feature for the map that starts the interaction running if you sit on the page without doing anything for a set number of seconds. There's also a social sharing component for each story that I developed with the current sharing capabilities at the time. 
      </p>
      <h3>SERVICES PROVIDED</h3>    
      <ul>
        <li>Front End Development</li>
        <li>Dynamic Google Map Data Integration</li>
        <li>Social Media Integration</li>
      </ul>
      <a class="work-external-link-text" href="https://www.caterpillar.com/en/company/caterpillar-foundation.html" target="_blank"><span>Visit</span> the site</a>
    `,
    logo: "logo-caterpillar.png",
    images: ['sample-shenshen-02.png', 'sample-shenshen-01.png'],
    imageSet: [
      {
        src: 'sample-caterpillar-06.png',
        caption: 'Custom Google Map Skinning'
      },
      {
        src: 'sample-caterpillar-05.png',
        caption: 'Mapping and Custom Markers'
      },
      {
        src: 'sample-caterpillar-07.png',
        caption: 'Marker Display Filtering'
      },
      {
        src: 'sample-caterpillar-01.png',
        caption: 'Photo Story Content Display'
      },
      {
        src: 'sample-caterpillar-02.png',
        caption: 'Text Story Content Display'
      },
      {
        src: 'sample-caterpillar-03.png',
        caption: 'Video Story Content'
      },
      {
        src: 'sample-caterpillar-04.png',
        caption: 'Video Story Content Playback'
      },
    ],
  },

  uscc: {
    client: "uscc",
    title: "U.S. Cellular Display Advertising",
    link: "",
    description: `
        <p>I started working on U.S. Cellular display advertising (Flash) and landing pages (HTML/CSS/JS) in 2014 as a subcontractor for Chicago-based Frequency540. I was brought onto the team to help with the banners that were being dynamically managed with Flashtalking.</p>
        
        <p>Eventually I helped take U.S. Cellular's online advertising from Flash over to HTML5 while working with Flashtalking to deliver dynamic online ads in various sizes and creative campaigns.</p>
                
        <p>Frequency540 was folded into The Abundance and acquired by Leo Burnett in January 2017. I was still developing a few banners for the creative team at Leo Burnett/USCC in December of 2018.</p>
        
        <p>Lots of banners, tons of animation. There were some cool and challenging concepts the entire time. Up above are just a few of the recent and challenging.</p>
    `,
    logo: "logo-uscc.png",
    imageSet: [
      {
        src: 'sample-uscc-01.png',
        caption: 'HTML5 Animated Display Ads'
      },
    ],
    adSource: [
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/uscc/uscc-arc-2017-prepaid-plans-300x250_agent/'
      },
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/uscc/uscc-p4-holiday-glove-wipe-300x250_agent'
      },
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/uscc/uscc-p1a-squeegee-300x250_agent'
      },
    ]
  },

  shenshen: {
    client: "shenshen",
    title: "Shen Shen Website",
    link: "https://shenshenhealth.com",
    description: `
    <h2>ABOUT SHEN SHEN</h2>
    <p>Shen Shen Health & Harmony has been providing the Chicago area with acupuncture, Traditional Chinese Medicine,
        massage and bodywork services since 2004. </p>
    <h2>ABOUT THE PROJECT</h2>  
    <p>Bob Jones, one of the practitioners at Shen Shen, purchased the business along with its website. The original
        site's content was detailed and getting good results with web searches, but the visuals and site organization needed
        an update.</p>
    <p>Bob also wanted a site that was easier to update. The solution, WordPress with a responsive custom theme.</p>
    <p>I had Bob work through some branding exercises to help inform the visual style and tone of the site.</p>
    <h3>SERVICES PROVIDED</h3>
    <ul>
      <li>Visual Design</li>
      <li>Front End Development</li>
      <li>Web Server Configuration</li>
      <li>Responsive Custom Theme for WordPress</li>
    </ul>
    <a class="work-external-link-text" href="https://shenshenhealth.com" target="_blank"><span>Visit</span> the site</a>
    `,
    logo: "logo-shenshen.svg",
    images: ['sample-shenshen-02.png', 'sample-shenshen-01.png'],
    imageSet: [
      {
        src: 'sample-shenshen-01.png',
        caption: 'Website homepage'
      },
      {
        src: 'sample-shenshen-02.png',
        caption: 'Style tile and mobile layout.'
      },
    ],
  },

  steelreserve: {
    client: "steelreserve",
    title: "Steel Reserve Animated Display Ads",
    description: `
    <h2>THE GIST</h2>
<p>The animation on these ads ended up being short and glichy, just like the creative team wanted. When we kicked off the project the team had a pretty good idea on how the animation should look and feel, and sometimes the best way to see is to develop some animation concepts.</p>
    
    <h3>EXPLORING OPTIONS</h3>
    <p> The links below show some of the iteration that can be done when we work together.</p>
    <ul>
    <li><a class="work-external-link-text" target="_blank" href="https://workalicious.work/ads/steelreserve/SRAS_Equity-300x250-R1/">
    Round 1: pulling</a></li>
    <li><a class="work-external-link-text" target="_blank" href="https://workalicious.work/ads/steelreserve/SRAS_Equity-300x250-R2/">
    Round 2: super glichy</a></li>
    <li><a class="work-external-link-text" target="_blank" href="https://workalicious.work/ads/steelreserve/SRAS_Equity-300x250-R3/">
    Round 3: background moves</a></li>
    <li><a class="work-external-link-text" target="_blank" href="https://workalicious.work/ads/steelreserve/SRAS_Equity-300x250-R4/">
    Round 4: everything lightly</a></li>
</ul>
    <p>I think the end result was pretty cool and just right. This was done in several sizes and also converted into .gif animations.</p>`,
    logo: "logo-steelreserve.png",
    images: ['sample-shenshen-02.png', 'sample-shenshen-01.png'],
    imageSet: [
      {
        src: 'sample-steelreserve-01.png',
        caption: 'HTML5 Animated Display Ads'
      },
    ],
    adSource: [
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/steelreserve/SRAS_Equity-300x250/'
      },
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/steelreserve/SRAS_Flavor-300x250/'
      },
    ]
  },

  cibc: {
    client: "cibc",
    title: "CIBC Animated Display Advertising",
    description: `<p>These ad concepts were developed for Sponge to present to their client, The Private Bank, which at the time was being acquired by Canada's CIBC.</p>
    <p>
    Sponge was creating the awareness campaign around The Private Bank's name change and they wanted to present some new ideas to CIBC focusing on the CIBC brand and Percival (the pig) burning the midnight oil was one of the concepts.
    </p>
    <p>They were tricky and intricate from a development point of view, animating using JavaScript (GSAP) and the right visual elements as the sprites — super challenge!</p> 
    `,
    logo: "logo-cibc.png",
    imageSet: [
      {
        src: 'sample-cibc-01.png',
        caption: 'HTML5 Display Ads'
      },
    ],
    adSource: [
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/cibc/cibc-palladian-plane-300x250/'
      },
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/cibc/cibc-palladian-midnight-300x250/'
      },
      {
        width: 300,
        height: 600,
        src: 'https://workalicious.work/ads/cibc/cibc-palladian-plane-300x600/'
      },
    ]
  },

  banquet: {
    client: "banquet",
    title: "Banquet Animated Display Ads",
    description: `
    <h2>THE GIST</h2>
    <p>From August 2016 to around March of 2018 I developed HTML5 animated ads for a variety of client/brands at Trisect/MatchMG. </p>
    <p>They had me add some extra push and pull to the animation in these that you can see on the typography. These are big visually and are going to make you hungry.</p>
    <h3>JUST MY OPINION</h3>
    <p>IF there isn't, there should really be a lipsum generator with pot pie language and other related deliciousness.</p>
    `,
    logo: "logo-banquet.png",
    imageSet: [
      {
        src: 'sample-banquet-01.png',
        caption: 'HTML5 Animated Display Ads'
      },
    ],
    adSource: [
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/banquet/Banquet-MegaBowls-300x250/'
      },
      {
        width: 320,
        height: 480,
        src: 'https://workalicious.work/ads/banquet/Banquet-MegaBowls-320x480/'
      },
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/banquet/Banquet-PotPies-300x250/'
      },
    ]
  },

  wesco: {
    client: "wesco",
    title: "Whole Earth Animated Display Ads",
    description: `     
      <h2>THE GIST</h2>
      <p>From August 2016 to around March of 2018 I developed HTML5 animated ads for a variety of client/brands at Trisect/MatchMG. </p>
      <p>I worked with the art director at Trisect to give these a feel that fit the Whole Earth brand.</p>
    <h3>MORE OPINION</h3>
    <p>If you need a guy that knows his way around photoshop and likes working out how to make stuff look good, I could be your guy.</p>
    `,
    logo: "logo-wesco.png",
    imageSet: [
      {
        src: 'sample-wesco-01.png',
        caption: 'HTML5 Animated Display Ads'
      },
    ],
    adSource: [
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/wesco/WESCO_Q4_BakingBlend_300x250/'
      },
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/wesco/WESCO_Q4_MM_AMNews_NatureSweet_300x250/'
      },
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/wesco/WESCO-FullLine-300x250/'
      },
    ]
  },

  theprivatebank: {
    client: "theprivatebank",
    title: "The Private Bank Animated Display Advertising",
    description: `
      <p>Sponge Chicago designed a series of online display ads to introduce a name change for their client, The Private Bank. I was contracted to develop the ads. One of the things I'm pretty good at is managing production and development on a whole series of creative around a campaign.</p>
      <p>This project was part of an ongoing relationship with Sponge Chicago, where I developed some fun rich media and sporting arena LED animated videos.</p>
    `,
    logo: "logo-theprivatebank.png",
    imageSet: [
      {
        src: 'sample-theprivatebank-01.png',
        caption: 'HTML5 Animated Display Ads'
      },
    ],
    adSource: [
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/tpb/tpb-cibc-1aGoldenStock-300x250-v2/index.html'
      },
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/tpb/tpb-cibc-a-300x250-endribbon/'
      },
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/tpb/TPB-CIBC-CafeChat-300x250/'
      },
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/tpb/tpb-cibc-1b-DinnerDuo-300x250/'
      },
    ]
  },

  uscc_frontend: {
    client: "uscc_frontend",
    title: "Front End Web Development",
    description: `
    <h3>PRODUCT PAGES FOR U.S. CELLULAR</h3>
    <p>These are pages that I developed for Frequency540 to be delivered to U. S. Cellular and integrated into their site. Originally developed in the Fall of 2015, a few of these are still in use on the U.S. Cellular website. The live version of <a class="work-external-link-text" href="https://www.uscellular.com/cell-phones-mobile-devices/index.html" target="_blank"><span>Phones and More</span></a> and <a class="work-external-link-text" href="https://www.uscellular.com/home-internet-phone-security/index.html" target="_blank"><span>Home Entertainment</span></a> are still up and running.</p>
    <h3>ORIGINAL DEVELOPMENT FILES (DESKTOP)</h3>
    <ul>
    <li><a class="work-external-link-text" target="_blank" href="https://workalicious.work/dev/usccfrontend/uscc-product-cat-desk/product-categorization-phones-and-more.html">Phones and More</a></li>
    <li><a class="work-external-link-text" target="_blank" href="https://workalicious.work/dev/usccfrontend/uscc-product-cat-desk/product-categorization-home-solutions.html">Home Solutions</a></li>
    <li><a class="work-external-link-text" target="_blank" href="https://workalicious.work/dev/usccfrontend/uscc-product-cat-desk/product-categorization-entertainment.html">Entertainment</a></li>
    <li><a class="work-external-link-text" target="_blank" href="https://workalicious.work/dev/usccfrontend/uscc-product-cat-desk/product-categorization-health-and-fitness.html">Health and Fitness</a></li>
    <li><a class="work-external-link-text" target="_blank" href="https://workalicious.work/dev/usccfrontend/uscc-product-cat-desk/product-categorization-on-the-go.html">On the Go</a></li>
    </ul>
        <h3 class="show-on-mobile">ORIGINAL DEVELOPMENT FILES (MOBILE)</h3>
    <ul class="show-on-mobile">
    <li><a class="work-external-link-text" target="_blank" href="https://workalicious.work/dev/usccfrontend/uscc-product-cat-mob/m_uscc-product-categorization-phones.html">Phones and More</a></li>
    <li><a class="work-external-link-text" target="_blank" href="https://workalicious.work/dev/usccfrontend/uscc-product-cat-mob/m_uscc-product-categorization-home-solutions.html">Home Solutions</a></li>
    <li><a class="work-external-link-text" target="_blank" href="https://workalicious.work/dev/usccfrontend/uscc-product-cat-mob/m_uscc-product-categorization-entertainment.html">Entertainment</a></li>
    <li><a class="work-external-link-text" target="_blank" href="https://workalicious.work/dev/usccfrontend/uscc-product-cat-mob/m_uscc-product-categorization-health-and-fitness.html">Health and Fitness</a></li>
    <li><a class="work-external-link-text" target="_blank" href="https://workalicious.work/dev/usccfrontend/uscc-product-cat-mob/m_uscc-product-categorization-on-the-go.html">On the Go</a></li>
    </ul>
   `,
    logo: "logo-uscc-frontend.png",
    imageSet: [
      {
        src: 'sample-usccfrontend-01.png',
        caption: '...'
      },
      {
        src: 'sample-usccfrontend-02.png',
        caption: '...'
      },
    ],
  },

  davidseeds: {
    client: "davidseeds",
    title: "HTML5 Display Advertising",
    description: `
    <h2>THE GIST</h2>
    <p>From August 2016 to around March of 2018 I developed HTML5 animated ads for a variety of client/brands at Trisect/MatchMG. </p>
    <p>David Seeds is a Conagra brand and a sponsor of the Chicago Cubs. These ads have some summertime baseball feel with subtle image parallax. Clean and smooth animation was a goal here.</p>
    <h2>NO NEED FOR WIKIPEDIA, GOT IT FOR YA.</h2>
    <p>The company was founded in 1926 by Armenian-American David Der Hairabedian of Fresno, California. Der Hairabedian first roasted sunflower seeds in his grocery store and packaged them in individual servings for a nickel. Eventually, his two sons, Ara and Aram, joined him in marketing the seeds to other retailers.

ConAgra acquired David & Sons from Nestle USA in December 2001.</p>
    `,
    logo: "logo-davidseeds.png",
    imageSet: [
      {
        src: 'sample-davidseeds-01.png',
        caption: 'HTML5 Animated Display Ads'
      },
    ],
    adSource: [
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/davidseeds/DavidSeeds-BringEm-300x250/'
      },
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/davidseeds/DavidSeeds-RFA-300x250/'
      },
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/davidseeds/DavidSeeds-PP-300x250/'
      },
    ]
  },

  pfchangs: {
    client: "pfchangs",
    title: "HTML5 Display Advertising",
    description: `
    <h2>THE GIST</h2>
    <p>From August 2016 to around March of 2018 I developed HTML5 animated ads for a variety of client/brands at Trisect/MatchMG.</p>
    <p>P.F. Chang's was my first project with Trisect. In addition to the ad development, I helped setup a workflow for development that our small team used to crank out quality ads for deployment across several ad servers.</p>
    <p>From Wikipedia, "In 2010, "P.F. Chang's China Bistro Home Menu" was introduced. The brand represents a group of frozen appetizers and meals that were sold under license by Unilever. ConAgra Foods, Inc. acquired the P.F. Chang's China Bistro Home Menu license from Unilever in August 2012."</p>
    <h2>THIS IS NOT IMPORTANT</h2>
    <p>I'm allergic to chicken, any poultry, really. And eggs, sesame, tree nuts and peanuts, that's not weird, right? I usually avoid eating out so that I don't have to stab myself with an Epipen.</p>
    `,
    logo: "logo-pfchangs.png",
    imageSet: [
      {
        src: 'sample-pfchangs-01.png',
        caption: 'HTML5 Animated Display Ads',
      },
    ],
    adSource: [
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/pfchangs/PFC-17-Family-ChickenFriedRice-300x250/'
      },
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/pfchangs/PFC-17-Family-OrangeChicken-300x250/'
      },
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/pfchangs/PFC-16-MegaSegment-300x250/'
      },
      // {
      //   width: 300,
      //   height: 250,
      //   src: 'https://workalicious.work/ads/pfchangs/PFC-16-12PersonHH-300x250/'
      // },
      // {
      //   width: 300,
      //   height: 250,
      //   src: 'https://workalicious.work/ads/pfchangs/PFC-16-FoodWine-300x250/'
      // },
      // {
      //   width: 300,
      //   height: 250,
      //   src: 'https://workalicious.work/ads/pfchangs/PFC-16-Millenials-300x250/'
      // },
    ]
  },

  equal: {
    client: "equal",
    title: "HTML5 Display Advertising",
    description: `
    <h2>THE GIST</h2>
    <p>From August 2016 to around March of 2018 I developed HTML5 animated ads for a variety of client/brands at Trisect/MatchMG. </p>
    <h3>I'LL MOVE IT BY A PIXEL</h3>
    <p>Each of these ads, in various sizes, had particular requests around the animation, like the way the Equal packet animated or the way the Flavor graphics animated. These were priorities and I try and be good about meeting expectations and getting the desired results.</p>
    `,
    logo: "logo-equal.png",
    imageSet: [
      {
        src: 'sample-equal-01.png',
        caption: 'HTML5 Animated Display Ads',
      },
    ],
    adSource: [
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/equal/EQUAL_Holiday_2016_300x250/'
      },
      {
        width: 300,
        height: 600,
        src: 'https://workalicious.work/ads/equal/EQUAL_National_Equity2_300x600/'
      },
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/equal/EQUAL_Q4_CafeCreamers_SaveCTA_300x250/'
      },
    ]
  },

  presencehealth: {
    client: "presencehealth",
    title: "HTML5 Display Advertising",
    description: `
      <p>I was contracted by Downtown Partners Chicago (DPC) to develop online advertising for their clients. They would provide storyboards and PSDs and I would develop and deliver HTML5 ads ready for different platforms. The work I did for DPC started out as Flash and then transitioned to HTML5 (CSS and JavaScript).</p>
      <p>I'm a long time user of Greensock's animation platform, for me it goes back to the days of Flash. Flash's Actionscript is a sibling to JavaScript. So, in addition to being able to manage lots of versions and creative, like in the case of Presence Health Online Advertising, I'm able to develop clean and optimized files from years of experience.</p>
    `,
    logo: "logo-presencehealth.png",
    imageSet: [
      {
        src: 'sample-presencehealth-01.png',
        caption: 'HTML5 Animated Display Ads',
      },
    ],
    adSource: [
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/presence/PMG-coldallergies-300x250/pmg-coldallergies-300x250.html'
      },
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/presence/PCP-FluShot-Older-300x250/pcp-flushot-older-300x250.html'
      },
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/presence/PMG-BackToSchool-300x250/pmg-backtoschool-300x250.html'
      },
    ]
  },

  omron: {
    client: "omron",
    title: "Omron Animated Display Ads",
    description: `
    <h2>THE GIST</h2>
    <p>From August 2016 to around March of 2018 I developed HTML5 animated ads for a variety of client/brands at Trisect/MatchMG. </p>
    
    <p>What the ads above don't show you is the number of creative versions, sizes and platforms I managed during this project with tight production and very clean straightforward animation.</p>
    `,
    logo: "logo-omron.png",
    imageSet: [
      {
        src: 'sample-omron-01.png',
        caption: 'HTML5 Animated Display Ads',
      },
    ],
    adSource: [
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/omron/300_250_TENS_PPP_P_Target'
      },
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/omron/300_250_TENS_HPP_L_CVS'
      },
    ]
  },

  realmedleys: {
    client: "realmedleys",
    title: "HTML5 Display Advertising",
    description: `
      <h2>THE GIST</h2>
      <p>I was contracted by Downtown Partners Chicago (DPC) to develop online advertising for their clients. They would provide storyboards and PSDs and I would develop and deliver HTML5 ads ready for different platforms. The work I did for DPC started out as Flash and then transitioned to HTML5 (CSS and JavaScript).</p>
      <h3>IT'S GOOD TO HAVE GOALS</h3>
      <p>My goal is to do the best I can and deliver on the desired look and feel for project, as well as delivering clean code on time. I've been moving things on the internet since we could and my art education was in visual communication. I'm blending the left-side and right-side of my thinking every day.</p>
    `,
    logo: "logo-realmedleys.png",
    imageSet: [
      {
        src: 'sample-quaker-01.png',
        caption: 'HTML5 Animated Display Ads',
      },
    ],
    adSource: [
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/quaker/quaker-realmedley-300x250/'
      },
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/quaker/quaker-realmedley-hispanic-300x250/'
      },
      {
        width: 300,
        height: 600,
        src: 'https://workalicious.work/ads/quaker/quaker-realmedley-300x600/'
      },
      {
        width: 320,
        height: 100,
        src: 'https://workalicious.work/ads/quaker/quaker-realmedley-320x100/'
      },
      //   {
      //     width: 160,
      //     height: 600,
      //     src: 'https://workalicious.work/ads/quaker/quaker-realmedley-160x600/'
      //   },
      //   {
      //     width: 728,
      //     height: 90,
      //     src: 'https://workalicious.work/ads/quaker/quaker-realmedley-728x90/'
      //   },
    ]
  },

  cheetos: {
    client: "cheetos",
    title: "Cheetos Animated Display Ads",
    description: `
    <h2>THE GIST</h2>
    <p>From August 2016 to around March of 2018 I developed HTML5 animated ads for a variety of client/brands at Trisect/MatchMG.</p><p>These were just fun to do. A few sizes in English and French versions. Doigts de fromage.</p>
    <p></p>
    `,
    logo: "logo-cheetos.png",
    imageSet: [
      {
        src: 'sample-cheetos-01.png',
        caption: 'HTML5 Animated Display Ads',
      },
    ],
    adSource: [
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/cheetos/Cheetos-Wave2-Cheeteorites-English-300x250/'
      },
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/cheetos/Cheetos-Wave1-TheyreHere-English-300x250/'
      },
    ]
  },

  chamberlain: {
    client: "chamberlain",
    title: "Chamberlain Animated Display Ads",
    description: `
    <h2>THE GIST</h2>
    <p>From August 2016 to around March of 2018 I developed HTML5 animated ads for a variety of client/brands at Trisect/MatchMG. </p>
    <h3>WORKALICIOUSNESS</h3>
    <p>These ads had several creative versions, sizes and media delivery platforms. The focus for me was tight production and  clean animations, with some simple, eye-catching movement.</p>
    `,
    logo: "logo-chamberlain.png",
    imageSet: [
      {
        src: 'sample-chamberlain-01.png',
        caption: 'HTML5 Animated Display Ads',
      },
    ],
    adSource: [
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/chamberlain/CHAM-Homebridge-HeySiri-300x250/'
      },
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/chamberlain/Chamberlain-DTC-A-300x250/'
      },
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/chamberlain/CHAM-SGH-BestBuy-300x250/'
      },
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/chamberlain/Chamberlain-DTC-B-v2-300x250/'
      },
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/chamberlain/CHAM-Homebridge-KindaAwesome-300x250/'
      },
    ]
  },

  bertolli: {
    client: "bertolli",
    title: "HTML5 Display Advertising",
    description: `
    <h2>THE GIST</h2>
    <p>From August 2016 to around March of 2018 I developed HTML5 animated ads for a variety of client/brands at Trisect/MatchMG. </p>
    <p>One of the challenges for online ads is creating quality assets to meet a specification. It's possible with good production.</p>
    `,
    logo: "logo-bertolli.png",
    imageSet: [
      {
        src: 'sample-bertolli-01.png',
        caption: 'HTML5 Animated Display Ads',
      },
    ],
    adSource: [
      {
        width: 300,
        height: 250,
        src: 'https://workalicious.work/ads/bertolli/Bertolli-Job1Impress-300x250/'
      },
      {
        width: 320,
        height: 480,
        src: 'https://workalicious.work/ads/bertolli/Bertolli-Job1Impress-320x480/'
      },
      {
        width: 480,
        height: 320,
        src: 'https://workalicious.work/ads/bertolli/Bertolli-Job1Impress-480x320/'
      },
    ]
  },

};

// logo array on home
let portfolioData = [
  {
    client: "sca",
    title: "HTML5 Display Advertising",
    description: "Description goes here.",
    logo: "logo-sca.png",
    images: ['sample-sample.png', 'sample-shenshen-01.png'],
    imageSet: [
      {
        src: 'sample-shenshen-01.png',
        caption: 'Website homepage'
      },
      {
        src: 'sample-shenshen-02.png',
        caption: 'Style tile and mobile layout.'
      },
    ],
  },

  {
    client: "range",
    title: "HTML5 Display Advertising",
    description: "Description goes here.",
    logo: "logo-range.png",
    images: ['sample-shenshen-02.png', 'sample-shenshen-01.png'],
    imageSet: [
      {
        src: 'sample-shenshen-01.png',
        caption: 'Website homepage'
      },
      {
        src: 'sample-shenshen-02.png',
        caption: 'Style tile and mobile layout.'
      },
    ],
  },

  {
    client: "caterpillar",
    title: "HTML5 Display Advertising",
    description: "Description goes here.",
    logo: "logo-caterpillar.png",
    images: ['sample-shenshen-02.png', 'sample-shenshen-01.png'],
    imageSet: [
      {
        src: 'sample-shenshen-01.png',
        caption: 'Website homepage'
      },
      {
        src: 'sample-shenshen-02.png',
        caption: 'Style tile and mobile layout.'
      },
    ],
  },

  {
    client: "uscc",
    title: "HTML5 Display Advertising",
    description: "Description goes here.",
    logo: "logo-uscc.png",
    images: ['sample-shenshen-02.png', 'sample-shenshen-01.png'],
    imageSet: [
      {
        src: 'sample-shenshen-01.png',
        caption: 'Website homepage'
      },
      {
        src: 'sample-shenshen-02.png',
        caption: 'Style tile and mobile layout.'
      },
    ],
  },

  {
    client: "shenshen",
    title: "HTML5 Display Advertising",
    description: `Description <strong>goes</strong> here.`,
    logo: "logo-shenshen.svg",
    images: ['sample-shenshen-02.png', 'sample-shenshen-01.png'],
    imageSet: [
      {
        src: 'sample-shenshen-01.png',
        caption: 'Website homepage'
      },
      {
        src: 'sample-shenshen-02.png',
        caption: 'Style tile and mobile layout.'
      },
    ],
  },

  {
    client: "cibc",
    title: "HTML5 Display Advertising",
    description: "Description goes here.",
    logo: "logo-cibc.png",
    images: ['sample-shenshen-02.png', 'sample-shenshen-01.png'],
    imageSet: [
      {
        src: 'sample-shenshen-01.png',
        caption: 'Website homepage'
      },
      {
        src: 'sample-shenshen-02.png',
        caption: 'Style tile and mobile layout.'
      },
    ],
  },

  {
    client: "presencehealth",
    title: "HTML5 Display Advertising",
    description: "Description goes here.",
    logo: "logo-presencehealth.png",
    images: ['sample-shenshen-02.png', 'sample-shenshen-01.png'],
    imageSet: [
      {
        src: 'sample-shenshen-01.png',
        caption: 'Website homepage'
      },
      {
        src: 'sample-shenshen-02.png',
        caption: 'Style tile and mobile layout.'
      },
    ],
  },

  {
    client: "steelreserve",
    title: "HTML5 Display Advertising",
    description: "goes here.",
    logo: "logo-steelreserve.png",
    images: ['sample-shenshen-02.png', 'sample-shenshen-01.png'],
    imageSet: [
      {
        src: 'sample-shenshen-01.png',
        caption: 'Website homepage'
      },
      {
        src: 'sample-shenshen-02.png',
        caption: 'Style tile and mobile layout.'
      },
    ],
  },
  /*

    {
    client: "wesco",
    title: "HTML5 Display Advertising",
    description: "goes here.",
    logo: "logo-wesco.png",
        images: ['sample-shenshen-02.png', 'sample-shenshen-01.png'],
    imageSet: [
      {
        src: 'sample-shenshen-01.png',
        caption: 'Website homepage'
      },
      {
        src: 'sample-shenshen-02.png',
        caption: 'Style tile and mobile layout.'
      },
    ],
  },

    {
    client: "banquet",
    title: "HTML5 Display Advertising",
    description: "goes here.",
    logo: "logo-banquet.png",
        images: ['sample-shenshen-02.png', 'sample-shenshen-01.png'],
    imageSet: [
      {
        src: 'sample-shenshen-01.png',
        caption: 'Website homepage'
      },
      {
        src: 'sample-shenshen-02.png',
        caption: 'Style tile and mobile layout.'
      },
    ],
  },

  {
    client: "theprivatebank",
    title: "HTML5 Display Advertising",
    description: "Description goes here.",
    logo: "logo-theprivatebank.png",
        images: ['sample-shenshen-02.png', 'sample-shenshen-01.png'],
    imageSet: [
      {
        src: 'sample-shenshen-01.png',
        caption: 'Website homepage'
      },
      {
        src: 'sample-shenshen-02.png',
        caption: 'Style tile and mobile layout.'
      },
    ],
  },

  {
    client: "rta",
    title: "HTML5 Display Advertising",
    description: "Description goes here.",
    logo: "logo-rta.png",
        images: ['sample-shenshen-02.png', 'sample-shenshen-01.png'],
    imageSet: [
      {
        src: 'sample-shenshen-01.png',
        caption: 'Website homepage'
      },
      {
        src: 'sample-shenshen-02.png',
        caption: 'Style tile and mobile layout.'
      },
    ],
  },

  {
    client: "davidseeds",
    title: "HTML5 Display Advertising",
    description: "Description goes here.",
    logo: "logo-davidseeds.png",
        images: ['sample-shenshen-02.png', 'sample-shenshen-01.png'],
    imageSet: [
      {
        src: 'sample-shenshen-01.png',
        caption: 'Website homepage'
      },
      {
        src: 'sample-shenshen-02.png',
        caption: 'Style tile and mobile layout.'
      },
    ],
  },
  {
    client: "pfchangs",
    title: "HTML5 Display Advertising",
    description: "Description goes here.",
    logo: "logo-pfchangs.png",
        images: ['sample-shenshen-02.png', 'sample-shenshen-01.png'],
    imageSet: [
      {
        src: 'sample-shenshen-01.png',
        caption: 'Website homepage'
      },
      {
        src: 'sample-shenshen-02.png',
        caption: 'Style tile and mobile layout.'
      },
    ],
  },
  {
    client: "equal",
    title: "HTML5 Display Advertising",
    description: "Description goes here.",
    logo: "logo-equal.png",
        images: ['sample-shenshen-02.png', 'sample-shenshen-01.png'],
    imageSet: [
      {
        src: 'sample-shenshen-01.png',
        caption: 'Website homepage'
      },
      {
        src: 'sample-shenshen-02.png',
        caption: 'Style tile and mobile layout.'
      },
    ],
  },



  {
    client: "omron",
    title: "HTML5 Display Advertising",
    description: "Description goes here.",
    logo: "logo-omron.png",
        images: ['sample-shenshen-02.png', 'sample-shenshen-01.png'],
    imageSet: [
      {
        src: 'sample-shenshen-01.png',
        caption: 'Website homepage'
      },
      {
        src: 'sample-shenshen-02.png',
        caption: 'Style tile and mobile layout.'
      },
    ],
  },
  {
    client: "realmedleys",
    title: "HTML5 Display Advertising",
    description: "Description goes here.",
    logo: "logo-realmedleys.png",
        images: ['sample-shenshen-02.png', 'sample-shenshen-01.png'],
    imageSet: [
      {
        src: 'sample-shenshen-01.png',
        caption: 'Website homepage'
      },
      {
        src: 'sample-shenshen-02.png',
        caption: 'Style tile and mobile layout.'
      },
    ],
  },
  {
    client: "cheetos",
    title: "HTML5 Display Advertising",
    description: "Description goes here.",
    logo: "logo-cheetos.png",
        images: ['sample-shenshen-02.png', 'sample-shenshen-01.png'],
    imageSet: [
      {
        src: 'sample-shenshen-01.png',
        caption: 'Website homepage'
      },
      {
        src: 'sample-shenshen-02.png',
        caption: 'Style tile and mobile layout.'
      },
    ],
  },
  {
    client: "chamberlain",
    title: "HTML5 Display Advertising",
    description: "Description goes here.",
    logo: "logo-chamberlain.png",
        images: ['sample-shenshen-02.png', 'sample-shenshen-01.png'],
    imageSet: [
      {
        src: 'sample-shenshen-01.png',
        caption: 'Website homepage'
      },
      {
        src: 'sample-shenshen-02.png',
        caption: 'Style tile and mobile layout.'
      },
    ],
  },
  {
    client: "bertolli",
    title: "HTML5 Display Advertising",
    description: "Description goes here.",
    logo: "logo-bertolli.png",
        images: ['sample-shenshen-02.png', 'sample-shenshen-01.png'],
    imageSet: [
      {
        src: 'sample-shenshen-01.png',
        caption: 'Website homepage'
      },
      {
        src: 'sample-shenshen-02.png',
        caption: 'Style tile and mobile layout.'
      },
    ],
  },

  {
    client: "conagra",
    description: "Description goes here.",
    logo: "logo-conagra.png"
  },

  {
    client: "sepia",
    description: "Description goes here.",
    logo: "logo-sepia.png"
  },

  {
    client: "vvsupremo",
    description: "Description goes here.",
    logo: "logo-vvsupremo.png"
  },

  {
    client: "weiman",
    description: "Description goes here.",
    logo: "logo-weiman.png"
  },
  */
];

// export default myData
export {clientList, portfolioData, clientData};





// WEBPACK FOOTER //
// ./src/workData.js